import type { AlertProps } from "./alert.type";

import { Alert as AntdAlert } from "antd";
import { useTranslation } from "react-i18next";

export const Alert = ({
  display,
  title,
  type = "error",
  ...alertProps
}: AlertProps) => {
  const { t } = useTranslation();
  const defaultTitle = type === "error" ? t("form:error:invalid") : "";

  return (
    <>
      {display && (
        <AntdAlert
          title={title || defaultTitle}
          type={type}
          data-testid={`alert-${type}`}
          showIcon
          closable
          {...alertProps}
        />
      )}
    </>
  );
};
